import { AxiosInstance, AxiosRequestConfig } from 'axios';

import helper from './helper';
import { QuestionnairePayload, RequestPayload } from './types';
const ENDPOINT = 'huntertool/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getOutlets: (payload: RequestPayload) =>
    instance.get(ENDPOINT + 'outlets/' + helper.toQueryString(payload), config),
  postQuestionnaire: (payload: QuestionnairePayload) =>
    instance.post(ENDPOINT + 'questionnaire/post/', payload, config),
});
